import { Constructor } from 'interfaces/constructor';
import { WCCContentBlock } from '../blocks/block/block';
import { WCCContentBlockType } from '../blocks/block/block.interfaces';

export function MakeInlineWCCContentBlock<TBase extends Constructor<any[], WCCContentBlock>>(Base: TBase) {
    abstract class ExtendedWCCContentBlock extends Base {
        protected override getLength() {
            return this.content.length;
        }

        protected override getType(): WCCContentBlockType {
            return 'inline';
        }
    }

    return ExtendedWCCContentBlock;
}